(() => {
  document.querySelectorAll('.landing-hero-product').forEach((root) => initHero(root));

  function initHero(root) {
    initGallery(root);
    initVariantPicker(root);
    initBundleTiers(root);
    syncFormState(root);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const slides = root.querySelectorAll('[data-gallery-main] [data-gallery-index]');
    const thumbs = root.querySelectorAll('[data-gallery-thumbs] [data-thumb-index]');
    if (!slides.length || !thumbs.length) return;

    const show = (i) => {
      slides.forEach(s => s.classList.toggle('is-active', +s.dataset.galleryIndex === i));
      thumbs.forEach(t => t.classList.toggle('is-active', +t.dataset.thumbIndex === i));
    };
    thumbs.forEach(t => {
      t.addEventListener('click', () => show(+t.dataset.thumbIndex));
    });
  }

  /* ---------- Variant picker (swatch / button / dropdown) ---------- */
  function initVariantPicker(root) {
    const variantsScript = root.querySelector('[data-product-variants]');
    if (!variantsScript) return;
    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch { return; }

    const variantInput = root.querySelector('[data-variant-id-input]');
    const priceEl = root.querySelector('[data-current-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const saveBadge = root.querySelector('[data-save-badge]');
    const atcButton = root.querySelector('[data-atc-button]');
    const atcLabel = root.querySelector('[data-atc-label]');

    // Collect option inputs grouped by index
    const inputs = root.querySelectorAll('[data-option-index]');
    if (!inputs.length) return;

    const optionsCount = Math.max(...Array.from(inputs).map(i => +i.dataset.optionIndex)) + 1;

    const getCurrentValues = () => {
      const result = new Array(optionsCount);
      // For radios, find checked. For selects, take .value
      Array.from(inputs).forEach((el) => {
        const idx = +el.dataset.optionIndex;
        if (el.tagName === 'SELECT') {
          result[idx] = el.value;
        } else if (el.type === 'radio' && el.checked) {
          result[idx] = el.value;
        }
      });
      return result;
    };

    const updateSelectedClasses = () => {
      // For each radio set, mark its parent label is-selected
      Array.from(inputs).forEach((el) => {
        if (el.type !== 'radio') return;
        const wrapper = el.closest('.landing-hero-product__swatch, .landing-hero-product__btn-pill');
        if (wrapper) {
          if (el.checked) wrapper.classList.add('is-selected');
          else wrapper.classList.remove('is-selected');
        }
      });
    };

    const update = () => {
      updateSelectedClasses();
      const chosen = getCurrentValues();

      chosen.forEach((val, idx) => {
        const lbl = root.querySelector(`[data-option-value="${idx}"]`);
        if (lbl && val) lbl.textContent = val;
      });

      const match = variants.find(v =>
        v.options.every((o, i) => o === chosen[i])
      );
      if (!match) return;

      if (variantInput) variantInput.value = match.id;
      root.dataset.variantId = match.id;
      root.dataset.variantPrice = match.price;

      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
          if (saveBadge) {
            const pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            saveBadge.textContent = `SAVE ${pct}%`;
            saveBadge.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveBadge) saveBadge.style.display = 'none';
        }
      }

      if (atcButton && atcLabel) {
        if (match.available) {
          atcButton.disabled = false;
          atcLabel.textContent = atcLabel.dataset.label || 'Add to Cart';
        } else {
          atcButton.disabled = true;
          atcLabel.textContent = 'Sold Out';
        }
      }

      refreshBundlePrices(root, match.price, match.compare_at_price);
    };

    inputs.forEach(el => el.addEventListener('change', update));
    updateSelectedClasses();
  }

  /* ---------- Per-unit variant picker texts (2026-10-12) ----------
     Önce bloğun data-variant-placeholder / data-variant-required attr'ları
     (backend hedef dilde yazar). Eski bloklarda boş → sayfa dili
     (document.documentElement.lang, ilk iki harf; es → es-419, pt → pt-BR)
     yedek sözlüğü → İngilizce. landing-atc-handler.js'teki yedekle AYNI sözlük.
     Sözlük fonksiyonun İÇİNDE: dosyanın başındaki initHero() çağrısı modül
     seviyesindeki bir const'tan önce koşar (TDZ → ReferenceError, hero ölür). */
  function variantPickerText(kind, blockEl) {
    const attr = kind === 'required' ? 'variantRequired' : 'variantPlaceholder';
    if (blockEl && blockEl.dataset && blockEl.dataset[attr]) return blockEl.dataset[attr];
    const texts = {
      en: { placeholder: 'Choose a variant', required: 'Please choose a variant.' },
      es: { placeholder: 'Elige una variante', required: 'Por favor, elige una variante.' },
      de: { placeholder: 'Variante wählen', required: 'Bitte wähle eine Variante.' },
      fr: { placeholder: 'Choisissez une variante', required: 'Veuillez choisir une variante.' },
      pt: { placeholder: 'Escolha uma variante', required: 'Por favor, escolha uma variante.' },
      it: { placeholder: 'Scegli una variante', required: 'Per favore, scegli una variante.' },
      nl: { placeholder: 'Kies een variant', required: 'Kies alsjeblieft een variant.' },
      tr: { placeholder: 'Varyant seçin', required: 'Lütfen bir varyant seçin.' },
      pl: { placeholder: 'Wybierz wariant', required: 'Proszę wybrać wariant.' },
    };
    const lang = String(document.documentElement.lang || '').slice(0, 2).toLowerCase();
    const dict = texts[lang] || texts.en;
    return dict[kind] || texts.en[kind];
  }

  /* ---------- Bundle tiers ----------
     v1.4.8 — DOM mutation kaldırıldı (selected state CSS `input:checked + .tier-card` ile).
     Editor'da tamamen bypass: Shopify.designMode true ise JS hiç bind olmaz, scroll-restore stabil. */
  function initBundleTiers(root) {
    if (window.Shopify && window.Shopify.designMode) return;

    const radios = root.querySelectorAll('.landing-hero-product__tier-radio');
    const qtyInput = root.querySelector('[data-quantity-input]');
    if (!radios.length) return;

    const apply = (radio) => {
      // selected state CSS sibling selector ile, JS DOM mutation yok
      const qty = parseInt(radio.dataset.tierQty, 10) || 1;
      if (qtyInput) qtyInput.value = String(qty);

      const total = parseInt(radio.dataset.tierTotal, 10);
      const atcTotal = root.querySelector('[data-atc-total]');
      if (atcTotal && !isNaN(total)) {
        atcTotal.textContent = ' — ' + formatMoney(total);
      }

      // ---- Per-unit variant picker (F7-R2/T1) ----
      // Her radio change'de önce tüm kapsayıcılar sıfırlanır; sadece seçili
      // kademenin "variant_picker" açık olan kapsayıcısı doldurulup gösterilir.
      root.querySelectorAll('[data-unit-picks]').forEach((el) => {
        el.hidden = true;
        el.innerHTML = '';
      });

      const tierIdx = radio.dataset.tierIdx;
      if (tierIdx === undefined) return;
      const picksEl = root.querySelector(`[data-unit-picks][data-tier-idx="${tierIdx}"]`);
      if (!picksEl) return;
      if (radio.dataset.variantPicker === undefined) return; // kapsayıcı hidden kalır

      const variantsScript = root.querySelector('script[data-bundle-variants]');
      if (!variantsScript) return;
      let variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch {
        return; // bozuk JSON tüm bloğu çökertmesin
      }
      if (!Array.isArray(variants)) return;

      const availableVariants = variants.filter((v) => v.available === true);
      const blockEl = picksEl.closest('[data-bundle]');
      const placeholderText = variantPickerText('placeholder', blockEl);
      const requiredText = variantPickerText('required', blockEl);

      for (let i = 0; i < qty; i++) {
        const select = document.createElement('select');
        select.className = 'landing-hero-product__option-select';
        select.setAttribute('data-unit-index', String(i));
        // landing-atc-handler.js "seçim eksik" uyarısını buradan okur.
        select.setAttribute('data-variant-required', requiredText);
        select.required = true;

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = placeholderText;
        select.appendChild(placeholder);

        availableVariants.forEach((v) => {
          const opt = document.createElement('option');
          opt.value = String(v.id);
          opt.textContent = v.title;
          select.appendChild(opt);
        });

        picksEl.appendChild(select);
      }

      picksEl.hidden = false;
    };

    radios.forEach(r => r.addEventListener('change', () => apply(r)));

    const checked = Array.from(radios).find(r => r.checked);
    if (checked) apply(checked);
  }

  function refreshBundlePrices(root, unitPrice, unitCompare) {
    // F7-R1 fix (adversarial review caught it): this used to query
    // '.landing-hero-product__tier' (no such class exists — the actual card
    // is '.landing-hero-product__tier-card') and then look for the radio as
    // a DESCENDANT of that label, but the radio is a preceding SIBLING, not
    // a child. Both mistakes together meant this whole function silently
    // matched zero elements and never ran on any real page. Iterating the
    // radios directly (a class that does exist) and reaching the label via
    // nextElementSibling matches the actual markup.
    const radios = root.querySelectorAll('.landing-hero-product__tier-radio');
    const tiersEl = root.querySelector('.landing-hero-product__tiers');
    const savingsLabel = (tiersEl && tiersEl.dataset.savingsLabel) || 'Save';
    radios.forEach(radio => {
      const li = radio.nextElementSibling;
      if (!li) return;
      const qty = parseInt(radio.dataset.tierQty, 10) || 1;
      // Per-tier, not block-wide: a legacy page with the old "Show amount +
      // percent" checkbox OFF could have different discount types per tier,
      // so the effective display mode is resolved per tier server-side too.
      const savingsDisplay = radio.dataset.savingsDisplay || 'both';

      const fullTotal = unitPrice * qty;
      // 2026-09-29 — same formulas as landing_bundle-tier.liquid (2.11.0), so the
      // re-priced card matches what Liquid renders to the cent:
      //   amount → full - min(full, amountCents)             (fixed amount per tier)
      //   exact  → full - floor(unit * exact / 100) * qty    (decimal percent)
      //   int %  → full - floor(unit * p / 100) * qty        (Liquid integer divided_by)
      // 2026-10-03 — percent discounts are per UNIT, rounded down: that is how
      // Shopify applies them at checkout (computing from the line total made the
      // card 1 cent cheaper than the cart). 1e-6 = float guard, same as Liquid.
      // Without the data-* attributes the integer-percent path is used.
      const amountCents = parseInt(radio.dataset.tierDiscountAmount, 10) || 0;
      const exactPct = parseFloat(radio.dataset.tierDiscountExact) || 0;
      const intPct = parseInt(radio.dataset.tierDiscount, 10) || 0;
      let discount;
      let discountPct;
      if (amountCents > 0) {
        discount = Math.min(fullTotal, amountCents);
        discountPct = fullTotal > 0 ? Math.floor(discount * 100 / fullTotal) : 0;
      } else if (exactPct > 0) {
        // velocco: kesirli yüzde = sabit tutarlı Shopify indirimi → toplamdan yuvarlanır (Liquid ile aynı)
        discount = Math.round(fullTotal * exactPct / 100);
        discountPct = Math.round(exactPct);
      } else {
        discount = Math.floor(unitPrice * intPct / 100) * qty;
        discountPct = intPct;
      }
      const discountedTotal = fullTotal - discount;

      radio.dataset.tierTotal = String(discountedTotal);
      radio.dataset.tierTotalFull = String(fullTotal);

      // 2026-10-12 (block 2.13.0) — manual compare-at override, mirrored from the
      // Liquid (tier_N_compare_at_price > 0): the struck price is the override,
      // "Save" is override − discounted total and the "% off" is
      // floor(saved × 100 / override) — a DISPLAY percent that is recomputed here
      // because it moves with the variant price (the override is fixed). The real
      // discount percent (data-tier-discount) stays untouched; it only prices the
      // card. Override ≤ discounted total → nothing shown (same guard as Liquid).
      // Without an override every line below is the pre-2.13.0 behaviour.
      const overrideCents = parseInt(radio.dataset.tierCompareOverride, 10) || 0;
      let compareCents = fullTotal;
      let saved = fullTotal - discountedTotal;
      let showCompare = saved > 0;
      let displayPct = discountPct;
      if (overrideCents > 0) {
        compareCents = overrideCents;
        showCompare = overrideCents > discountedTotal;
        saved = showCompare ? overrideCents - discountedTotal : 0;
        if (showCompare) displayPct = Math.floor(saved * 100 / overrideCents);
        radio.dataset.tierDisplayPct = String(displayPct);
      }

      const compareEl = li.querySelector('.landing-hero-product__tier-compare');
      const priceEl = li.querySelector('.landing-hero-product__tier-price');
      const savingsEl = li.querySelector('.landing-hero-product__tier-savings');

      if (priceEl) priceEl.textContent = formatMoney(discountedTotal);
      if (compareEl) {
        compareEl.textContent = showCompare ? formatMoney(compareCents) : '';
        compareEl.style.display = showCompare ? '' : 'none';
      }
      if (savingsEl) {
        if (saved > 0 && savingsDisplay !== 'none') {
          if (savingsDisplay === 'both') {
            savingsEl.textContent = `${savingsLabel} ${formatMoney(saved)} (${displayPct}% off)`;
          } else if (savingsDisplay === 'amount') {
            savingsEl.textContent = `${savingsLabel} ${formatMoney(saved)}`;
          } else {
            savingsEl.textContent = `${savingsLabel} ${displayPct}%`;
          }
          savingsEl.style.display = '';
        } else {
          savingsEl.textContent = '';
          savingsEl.style.display = 'none';
        }
      }

      // Update ATC total if this tier is currently selected
      if (radio.checked) {
        const atcTotal = root.querySelector('[data-atc-total]');
        if (atcTotal) atcTotal.textContent = ' — ' + formatMoney(discountedTotal);
      }
    });
  }

  /* ---------- Helpers ---------- */
  function syncFormState(root) {
    const form = root.querySelector('form');
    if (!form) return;
    // Ensure variant id stays in sync if user changes select after load
    form.addEventListener('submit', (e) => {
      const variantInput = root.querySelector('[data-variant-id-input]');
      if (variantInput && !variantInput.value) {
        e.preventDefault();
      }
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    const value = cents / 100;
    const symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? '' : '$';
    // Use Intl when shop locale is available
    try {
      const locale = (window.Shopify && window.Shopify.locale) || 'en-AU';
      const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(value);
    } catch {
      return symbol + value.toFixed(2);
    }
  }
})();
